import { render } from "./Podcast.vue?vue&type=template&id=04944a1e&scoped=true"
import script from "./Podcast.vue?vue&type=script&lang=js"
export * from "./Podcast.vue?vue&type=script&lang=js"

import "./Podcast.vue?vue&type=style&index=0&id=04944a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04944a1e"]])

export default __exports__